<template>
  <div>
    <!-- 标题 -->
    <div class="slb-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.name }}</BreadcrumbItem>
        <BreadcrumbItem to="/network/SlbMonitor">{{
          $t("alarms.network.loadBalancing.loadBalancing")
        }}</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.monitoringSummary") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="slb-top">
      <Row :gutter="16">
        <Col span="6" v-show="isAWS">
          <Select v-model="timeType" @on-change="changeTimeType(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isALY">
          <Select v-model="timeType" @on-change="changeTimeTypeALY(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>

        <Col span="6" v-show="isHTTPS">
          <Select v-model="timeType" @on-change="changeTimeTypeHTTPS(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isUDP">
          <Select v-model="timeType" @on-change="changeTimeTypeUDP(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-show="isTCP">
          <Select v-model="timeType" @on-change="changeTimeTypeTCP(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
      <Col
        span="6"
        v-for="(item, index) in this.$route.query.accountTypeName == 'Aliyun'
          ? alyList
          : this.$route.query.loadbalancerType == 'HTTP(S)'
          ? httpsList
          : this.$route.query.loadbalancerType == 'UDP'
          ? udpList
          : this.$route.query.loadbalancerType == 'TCP'
          ? tcpList
          : awsList"
        :key="index"
      >
        <Card :padding="8">
          <p slot="title">{{ item.title }}</p>
          <a href="#" slot="extra" @click.prevent="changeFull(item)">
            <Icon type="ios-expand" size="18" />
          </a>
          <div
            :id="item.id"
            :ref="item.id"
            style="width: 100%; height: 240px"
          ></div>
        </Card>
      </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal
      v-model="isShowModal"
      :mask-closable="false"
      :closable="false"
      width="65%"
    >
      <Row>
        <Col span="24">
          <h3>{{ lineTitle }}</h3>
          <div
            id="chart-part"
            ref="fullChart"
            style="width: 100%; height: 420px"
          ></div>
        </Col>
      </Row>
      <div slot="footer">
        <div>
          <Button @click="cancel">{{ $t("alarms.common.close") }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
export default {
  name: "SLB",
  data() {
    return {
      // 放大功能
      lineTitle: "",
      isShowModal: false,
      //阿里云折线图
      alyList: [
        {
          id: "numberOfBackendAbnormalECSInstances",
          title: this.$t(
            "alarms.network.loadBalancing.line.NumberOfAbnormalBackEndECSInstancesCount"
          ),
        },
        {
          id: "instanceTrafficRTX",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceTrafficRTX"
          ),
        },
        {
          id: "instancePacket",
          title: this.$t("alarms.network.loadBalancing.line.InstancePacket"),
        },
        {
          id: "instanceConnection",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceConnection"
          ),
        },

        {
          id: "instanceNewConnection",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceNewConnectionCount"
          ),
        },
        {
          id: "instanceDropTrafficRTX",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceDropTrafficRTX"
          ),
        },
        {
          id: "instanceDropPacketRTX",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceDropPacketRTX"
          ),
        },
        {
          id: "instanceDrops",
          title: this.$t("alarms.network.loadBalancing.line.InstanceDrops"),
        },
        {
          id: "instanceQps",
          title: this.$t("alarms.network.loadBalancing.line.InstanceQpsCount"),
        },
        {
          id: "instanceQpsUtilization",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceQpsUtilizationPercent"
          ),
        },
        {
          id: "instanceNewConnectionUtilization",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceNewConnectionUtilizationPercent"
          ),
        },
        {
          id: "instanceMaxConnectionUtilization",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceMaxConnectionUtilizationPercent"
          ),
        },
        {
          id: "instanceUpstreamRt",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceUpstreamRtMs"
          ),
        },
        {
          id: "instanceUpstreamCode",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceUpstreamCode"
          ),
        },
        {
          id: "instanceStatusCode",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceStatusCode"
          ),
        },
        {
          id: "instanceRt",
          title: this.$t("alarms.network.loadBalancing.line.InstanceRtms"),
        },
        {
          id: "instanceDropTrafficTX",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceDropTrafficTXBits"
          ),
        },
        {
          id: "instanceDropTrafficRX",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceDropTrafficRXBits"
          ),
        },
        {
          id: "instanceDropPacketRX",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceDropPacketRXCount"
          ),
        },
        {
          id: "instanceDropPacketTX",
          title: this.$t(
            "alarms.network.loadBalancing.line.InstanceDropPacketTXCount"
          ),
        },
      ],
      // aws折线图
      awsList: [
        {
          id: "unHealthyHostCounts",
          title: this.$t(
            "alarms.network.loadBalancing.line.TargetGroupHealthCheckStation"
          ),
        },
      ],
      //https折线图
      httpsList: [
        {
          id: "backendLatencies",
          title: this.$t("alarms.network.loadBalancing.line.BackendLatencies"),
        },
        {
          id: "backendRequestBytesCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.BackendRequestBytesCount"
          ),
        },
        {
          id: "backendRequestCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.BackendRequestCount"
          ),
        },
        {
          id: "backendResponseBytesCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.BackendResponseBytesCount"
          ),
        },
        {
          id: "internalBackendLatencies",
          title: this.$t(
            "alarms.network.loadBalancing.line.InternalBackendLatencies"
          ),
        },
        {
          id: "internalRequestCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.InternalRequestCount"
          ),
        },
        {
          id: "internalRequestBytesCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.InternalRequestBytesCount"
          ),
        },
        {
          id: "internalResponseBytesCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.InternalResponseBytesCount"
          ),
        },
        {
          id: "internalTotalLatencies",
          title: this.$t(
            "alarms.network.loadBalancing.line.InternalTotalLatencies"
          ),
        },
        {
          id: "requestCount",
          title: this.$t("alarms.network.loadBalancing.line.RequestCount"),
        },
        {
          id: "responseBytesCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.ResponseBytesCount"
          ),
        },
      ],
      //UDP折线图
      udpList: [
        {
          id: "udpEgressBytesCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.UdpEgressBytesCount"
          ),
        },
        {
          id: "udpEgressPacketsCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.UdpEgressPacketsCount"
          ),
        },
        {
          id: "udpIngressBytesCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.UdpIngressBytesCount"
          ),
        },
        {
          id: "udpIngressPacketsCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.UdpIngressPacketsCount"
          ),
        },
        {
          id: "udpInternalEgressBytesCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.UdpInternalEgressBytesCount"
          ),
        },
        {
          id: "udpInternalEgressPacketsCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.UdpInternalEgressPacketsCount"
          ),
        },
        {
          id: "udpInternalIngressBytesCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.UdpInternalIngressBytesCount"
          ),
        },
        {
          id: "udpInternalIngressPacketsCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.UdpInternalIngressPacketsCount"
          ),
        },
        {
          id: "udpClosedConnections",
          title: this.$t(
            "alarms.network.loadBalancing.line.UdpClosedConnections"
          ),
        },
        {
          id: "udpNewConnections",
          title: this.$t("alarms.network.loadBalancing.line.UdpNewConnections"),
        },
      ],
      //TCP折线图
      tcpList: [
        {
          id: "tcpEgressBytesCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.TcpEgressBytesCount"
          ),
        },
        {
          id: "tcpEgressPacketsCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.TcpEgressPacketsCount"
          ),
        },
        {
          id: "tcpIngressBytesCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.TcpIngressBytesCount"
          ),
        },
        {
          id: "tcpIngressPacketsCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.TcpIngressPacketsCount"
          ),
        },

        {
          id: "tcpInternalEgressBytesCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.TcpInternalEgressBytesCount"
          ),
        },
        {
          id: "tcpInternalEgressPacketsCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.TcpInternalEgressPacketsCount"
          ),
        },
        {
          id: "tcpInternalIngressBytesCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.TcpInternalIngressBytesCount"
          ),
        },
        {
          id: "tcpInternalIngressPacketsCount",
          title: this.$t(
            "alarms.network.loadBalancing.line.TcpInternalIngressPacketsCount"
          ),
        },
        {
          id: "tcpClosedConnections",
          title: this.$t(
            "alarms.network.loadBalancing.line.TcpClosedConnections"
          ),
        },
        {
          id: "tcpNewConnections",
          title: this.$t("alarms.network.loadBalancing.line.TcpNewConnections"),
        },
      ],
      isAWS: false,
      isALY: false,
      isHTTPS: false,
      isUDP: false,
      isTCP: false,
      timeType: 0,
      timeList: [],
      // echarts实例
      chart: "",
      chartInflowDataVolume: "",
      chartNumberOfBackendAbnormalECSInstances: "",
      chartDropConnection: "",
      chartInstanceDropConnection: "",
      chartUnHealthyHostCounts: "",
      chartInstancePacket: "",
      chartInstanceConnection: "",
      chartInstanceTrafficRTX: "",
      chartInstanceNewConnection: "",
      chartInstanceQps: "",
      chartInstanceDropTrafficRTX: "",
      chartInstanceDropPacketRTX: "",
      chartInstanceDrops: "",
      chartInstanceQpsUtilization: "",
      chartInstanceNewConnectionUtilization: "",
      chartInstanceMaxConnectionUtilization: "",
      chartInstanceUpstreamRt: "",
      chartInstanceUpstreamCode: "",
      chartInstanceStatusCode: "",
      chartInstanceRt: "",
      chartInstanceDropTrafficTX: "",
      chartInstanceDropTrafficRX: "",
      chartInstanceDropPacketRX: "",
      chartInstanceDropPacketTX: "",
      chartBackendLatencies: "",
      chartBackendRequestBytesCount: "",
      chartBackendRequestCount: "",
      chartBackendResponseBytesCount: "",
      chartInternalBackendLatencies: "",
      chartInternalRequestCount: "",
      chartInternalRequestBytesCount: "",
      chartInternalResponseBytesCount: "",
      chartInternalTotalLatencies: "",
      chartRequestCount: "",
      chartResponseBytesCount: "",
      chartTcpEgressBytesCount: "",
      chartTcpEgressPacketsCount: "",
      chartTcpIngressBytesCount: "",
      chartTcpIngressPacketsCount: "",
      chartTcpInternalEgressBytesCount: "",
      chartTcpInternalEgressPacketsCount: "",
      chartTcpInternalIngressBytesCount: "",
      chartTcpInternalIngressPacketsCount: "",
      chartTcpClosedConnections: "",
      chartTcpNewConnections: "",
      chartUdpEgressBytesCount: "",
      chartUdpEgressPacketsCount: "",
      chartUdpIngressBytesCount: "",
      chartUdpIngressPacketsCount: "",
      chartUdpInternalEgressBytesCount: "",
      chartUdpInternalEgressPacketsCount: "",
      chartUdpInternalIngressBytesCount: "",
      chartUdpInternalIngressPacketsCount: "",
      chartUdpClosedConnections: "",
      chartUdpNewConnections: "",
      portFlowPersecondOption: {},
      inflowDataVolumeOption: {},
      numberOfBackendAbnormalECSInstancesOption: {},
      dropConnectionsOption: {},
      unHealthyHostCountsOption: {},
      instancePacketOption: {},
      instanceConnectionOption: {},
      instanceTrafficRTXOption: {},
      instanceNewConnectionOption: {},
      instanceDropTrafficRTXOption: {},
      instanceDropPacketRTXOption: {},
      instanceDropsOption: {},
      instanceQpsOption: {},
      instanceQpsUtilizationOption: {},
      instanceNewConnectionUtilizationOption: {},
      instanceMaxConnectionUtilizationOption: {},
      instanceUpstreamRtOption: {},
      instanceUpstreamCodeOption: {},
      instanceStatusCodeOption: {},
      instanceRtOption: {},
      instanceDropTrafficTXOption: {},
      instanceDropTrafficRXOption: {},
      instanceDropPacketRXOption: {},
      instanceDropPacketTXOption: {},
      backendLatenciesOption: {},
      backendRequestBytesCountOption: {},
      backendRequestCountOption: {},
      backendResponseBytesCountOption: {},
      internalBackendLatenciesOption: {},
      internalRequestCountOption: {},
      internalRequestBytesCountOption: {},
      internalResponseBytesCountOption: {},
      internalTotalLatenciesOption: {},
      tcpEgressBytesCountOption: {},
      tcpEgressPacketsCountOption: {},
      tcpIngressBytesCountOption: {},
      tcpIngressPacketsCountOption: {},
      tcpInternalEgressBytesCountOption: {},
      tcpInternalEgressPacketsCountOption: {},
      tcpInternalIngressBytesCountOption: {},
      tcpInternalIngressPacketsCountOption: {},
      tcpClosedConnectionsOption: {},
      tcpNewConnectionsOption: {},
      udpEgressBytesCountOption: {},
      udpEgressPacketsCountOption: {},
      udpIngressBytesCountOption: {},
      udpIngressPacketsCountOption: {},
      udpInternalEgressBytesCountOption: {},
      udpInternalEgressPacketsCountOption: {},
      udpInternalIngressBytesCountOption: {},
      udpInternalIngressPacketsCountOption: {},
      udpClosedConnectionsOption: {},
      udpNewConnectionsOption: {},
      requestCountOption: {},
      responseBytesCountOption: {},
      // 数组
      unhealthyServerCount: [],
      xaxisData: [],
      unHealthyHostCountsList: [],
      unHealthyHostCounts: [],
      xaxisDataAWS: [],
      instancePacketRX: [],
      instancePacketTX: [],
      instanceActiveConnection: [],
      instanceInactiveConnection: [],
      instanceMaxConnection: [],
      instanceTrafficRX: [],
      instanceTrafficTX: [],
      instanceDropTrafficRX: [],
      instanceDropTrafficTX: [],
      instanceDropPacketRX: [],
      instanceDropPacketTX: [],
      instanceNewConnection: [],
      instanceDropConnection: [],
      instanceQps: [],
      instanceQpsUtilization: [],
      instanceNewConnectionUtilization: [],
      instanceMaxConnectionUtilization: [],
      instanceUpstreamRt: [],
      instanceUpstreamCode4xx: [],
      instanceUpstreamCode5xx: [],
      instanceStatusCode2xx: [],
      instanceStatusCode3xx: [],
      instanceStatusCode4xx: [],
      instanceStatusCode5xx: [],
      instanceRt: [],
      instanceDropTrafficTX: [],
      instanceDropTrafficRX: [],
      instanceDropPacketRX: [],
      instanceDropPacketTX: [],
      backendLatencies: [],
      backendRequestBytesCount: [],
      backendRequestCount: [],
      backendResponseBytesCount: [],
      internalBackendLatencies: [],
      internalRequestCount: [],
      internalRequestBytesCount: [],
      internalResponseBytesCount: [],
      internalTotalLatencies: [],
      requestCount: [],
      responseBytesCount: [],
      instanceDrops: [],
      tcpEgressBytesCount: [],
      tcpEgressPacketsCount: [],
      tcpIngressBytesCount: [],
      tcpIngressPacketsCount: [],
      tcpInternalEgressBytesCount: [],
      tcpInternalEgressPacketsCount: [],
      tcpInternalIngressBytesCount: [],
      tcpInternalIngressPacketsCount: [],
      tcpClosedConnections: [],
      tcpNewConnections: [],
      udpEgressBytesCount: [],
      udpEgressPacketsCount: [],
      udpIngressBytesCount: [],
      udpIngressPacketsCount: [],
      udpInternalEgressBytesCount: [],
      udpInternalEgressPacketsCount: [],
      udpInternalIngressBytesCount: [],
      udpInternalIngressPacketsCount: [],
      udpClosedConnections: [],
      udpNewConnections: [],
    };
  },
  mounted: function () {
    if (
      this.$route.query.accountTypeName == "AWS" &&
      this.$route.query.loadbalancerType == "ELB"
    ) {
      this.isAWS = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartUnHealthyHostCounts.resize();
      });
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chart.resize();
        self.chartInflowDataVolume.resize();
        self.chartNumberOfBackendAbnormalECSInstances.resize();
        self.chartDropConnection.resize();
        self.chartInstanceDropConnection.resize();
        self.chartInstancePacket.resize();
        self.chartInstanceConnection.resize();
        self.chartInstanceTrafficRTX.resize();
        self.chartInstanceNewConnection.resize();
        self.chartInstanceDropTrafficRTX.resize();
        self.chartInstanceDropPacketRTX.resize();
        self.chartInstanceDrops.resize();
        self.chartInstanceQps.resize();
        self.chartInstanceQpsUtilization.resize();
        self.chartInstanceNewConnectionUtilization.resize();
        self.chartInstanceMaxConnectionUtilization.resize();
        self.chartInstanceUpstreamRt.resize();
        self.chartInstanceUpstreamCode.resize();
        self.chartInstanceStatusCode.resize();
        self.chartInstanceRt.resize();
        self.chartInstanceDropTrafficTX.resize();
        self.chartInstanceDropTrafficRX.resize();
        self.chartInstanceDropPacketRX.resize();
        self.chartInstanceDropPacketTX.resize();
      });
    } else if (this.$route.query.loadbalancerType == "HTTP(S)") {
      this.isHTTPS = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartBackendLatencies.resize();
        self.chartBackendRequestBytesCount.resize();
        self.chartBackendRequestCount.resize();
        self.chartBackendResponseBytesCount.resize();
        self.chartInternalBackendLatencies.resize();
        self.chartInternalRequestCount.resize();
        self.chartInternalRequestBytesCount.resize();
        self.chartInternalResponseBytesCount.resize();
        self.chartInternalTotalLatencies.resize();
        self.chartRequestCount.resize();
        self.chartResponseBytesCount.resize();
      });
    } else if (this.$route.query.loadbalancerType == "UDP") {
      this.isUDP = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartUdpEgressBytesCount.resize();
        self.chartUdpEgressPacketsCount.resize();
        self.chartUdpIngressBytesCount.resize();
        self.chartUdpIngressPacketsCount.resize();
        self.chartUdpInternalEgressBytesCount.resize();
        self.chartUdpInternalEgressPacketsCount.resize();
        self.chartUdpInternalIngressBytesCount.resize();
        self.chartUdpInternalIngressPacketsCount.resize();
        self.chartUdpClosedConnections.resize();
        self.chartUdpNewConnections.resize();
      });
    } else if (this.$route.query.loadbalancerType == "TCP") {
      this.isTCP = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartTcpEgressBytesCount.resize();
        self.chartTcpEgressPacketsCount.resize();
        self.chartTcpIngressBytesCount.resize();
        self.chartTcpIngressPacketsCount.resize();
        self.chartTcpInternalEgressBytesCount.resize();
        self.chartTcpInternalEgressPacketsCount.resize();
        self.chartTcpInternalIngressBytesCount.resize();
        self.chartTcpInternalIngressPacketsCount.resize();
        self.chartTcpClosedConnections.resize();
        self.chartTcpNewConnections.resize();
      });
    }
  },
  created() {
    if (
      this.$route.query.accountTypeName == "AWS" &&
      this.$route.query.loadbalancerType == "ELB"
    ) {
      this.isAWS = true;
      this.checkALBAndNlbStatistics();
    } else if (
      this.$route.query.accountTypeName == "Aliyun" &&
      this.$route.query.loadbalancerType == "SLB"
    ) {
      this.isALY = true;
      this.checkAliCloudSLBStatistics();
    } else if (
      this.$route.query.accountTypeName == "GCP" &&
      this.$route.query.loadbalancerType == "HTTP(S)"
    ) {
      this.isHTTPS = true;
      this.checkGcpLoadbalanceIndex();
    } else if (
      this.$route.query.accountTypeName == "GCP" &&
      this.$route.query.loadbalancerType == "UDP"
    ) {
      this.isUDP = true;
      this.checkGcpLoadbalanceUDPIndex();
    } else if (
      this.$route.query.accountTypeName == "GCP" &&
      this.$route.query.loadbalancerType == "TCP"
    ) {
      this.isTCP = true;
      this.checkGcpLoadbalanceTCPIndex();
    }
  },
  methods: {
    /******************放大********************************/
    changeFull: function (item) {
      this.isShowModal = true;
      this.lineTitle = item.title;
      this.$nextTick(() => {
        const chartFul = this.$refs.fullChart;
        if (chartFul) {
          const fullChart = this.$echarts.init(
            document.getElementById("chart-part")
          );
          fullChart.clear();
          // 阿里云
          if (item.id == "numberOfBackendAbnormalECSInstances") {
            var optionFll = this.numberOfBackendAbnormalECSInstancesOption;
          } else if (item.id == "instancePacket") {
            var optionFll = this.instancePacketOption;
          } else if (item.id == "instanceConnection") {
            var optionFll = this.instanceConnectionOption;
          } else if (item.id == "instanceTrafficRTX") {
            var optionFll = this.instanceTrafficRTXOption;
          } else if (item.id == "instanceNewConnection") {
            var optionFll = this.instanceNewConnectionOption;
          } else if (item.id == "instanceDropTrafficRTX") {
            var optionFll = this.instanceDropTrafficRTXOption;
          } else if (item.id == "instanceDropPacketRTX") {
            var optionFll = this.instanceDropPacketRTXOption;
          } else if (item.id == "instanceDrops") {
            var optionFll = this.instanceDropsOption;
          } else if (item.id == "instanceQps") {
            var optionFll = this.instanceQpsOption;
          } else if (item.id == "instanceQpsUtilization") {
            var optionFll = this.instanceQpsUtilizationOption;
          } else if (item.id == "instanceNewConnectionUtilization") {
            var optionFll = this.instanceNewConnectionUtilizationOption;
          } else if (item.id == "instanceMaxConnectionUtilization") {
            var optionFll = this.instanceMaxConnectionUtilizationOption;
          } else if (item.id == "instanceUpstreamRt") {
            var optionFll = this.instanceUpstreamRtOption;
          } else if (item.id == "instanceUpstreamCode") {
            var optionFll = this.instanceUpstreamCodeOption;
          } else if (item.id == "instanceStatusCode") {
            var optionFll = this.instanceStatusCodeOption;
          } else if (item.id == "instanceRt") {
            var optionFll = this.instanceRtOption;
          } else if (item.id == "instanceDropTrafficTX") {
            var optionFll = this.instanceDropTrafficTXOption;
          } else if (item.id == "instanceDropTrafficRX") {
            var optionFll = this.instanceDropTrafficRXOption;
          } else if (item.id == "instanceDropPacketRX") {
            var optionFll = this.instanceDropPacketRXOption;
          } else if (item.id == "instanceDropPacketTX") {
            var optionFll = this.instanceDropPacketTXOption;
          }

          // aws
          else if (item.id == "unHealthyHostCounts") {
            var optionFll = this.unHealthyHostCountsOption;
          }
          //gcp https
          else if (item.id == "backendLatencies") {
            var optionFll = this.backendLatenciesOption;
          } else if (item.id == "backendRequestBytesCount") {
            var optionFll = this.backendRequestBytesCountOption;
          } else if (item.id == "backendRequestCount") {
            var optionFll = this.backendRequestCountOption;
          } else if (item.id == "backendResponseBytesCount") {
            var optionFll = this.backendResponseBytesCountOption;
          } else if (item.id == "internalBackendLatencies") {
            var optionFll = this.internalBackendLatenciesOption;
          } else if (item.id == "internalRequestCount") {
            var optionFll = this.internalRequestCountOption;
          } else if (item.id == "internalRequestBytesCount") {
            var optionFll = this.internalRequestBytesCountOption;
          } else if (item.id == "internalResponseBytesCount") {
            var optionFll = this.internalResponseBytesCountOption;
          } else if (item.id == "internalTotalLatencies") {
            var optionFll = this.internalTotalLatenciesOption;
          } else if (item.id == "requestCount") {
            var optionFll = this.requestCountOption;
          } else if (item.id == "responseBytesCount") {
            var optionFll = this.responseBytesCountOption;
          } else if (item.id == "tcpEgressBytesCount") {
            var optionFll = this.tcpEgressBytesCountOption;
          } else if (item.id == "tcpEgressPacketsCount") {
            var optionFll = this.tcpEgressPacketsCountOption;
          } else if (item.id == "tcpIngressBytesCount") {
            var optionFll = this.tcpIngressBytesCountOption;
          } else if (item.id == "tcpIngressPacketsCount") {
            var optionFll = this.tcpIngressPacketsCountOption;
          } else if (item.id == "tcpInternalEgressBytesCount") {
            var optionFll = this.tcpInternalEgressBytesCountOption;
          } else if (item.id == "tcpInternalEgressPacketsCount") {
            var optionFll = this.tcpInternalEgressPacketsCountOption;
          } else if (item.id == "tcpInternalIngressBytesCount") {
            var optionFll = this.tcpInternalIngressBytesCountOption;
          } else if (item.id == "tcpInternalIngressPacketsCount") {
            var optionFll = this.tcpInternalIngressPacketsCountOption;
          } else if (item.id == "tcpClosedConnections") {
            var optionFll = this.tcpClosedConnectionsOption;
          } else if (item.id == "tcpNewConnections") {
            var optionFll = this.tcpNewConnectionsOption;
          } else if (item.id == "udpEgressBytesCount") {
            var optionFll = this.udpEgressBytesCountOption;
          } else if (item.id == "udpEgressPacketsCount") {
            var optionFll = this.udpEgressPacketsCountOption;
          } else if (item.id == "udpIngressBytesCount") {
            var optionFll = this.udpIngressBytesCountOption;
          } else if (item.id == "udpIngressPacketsCount") {
            var optionFll = this.udpIngressPacketsCountOption;
          } else if (item.id == "udpInternalEgressBytesCount") {
            var optionFll = this.udpInternalEgressBytesCountOption;
          } else if (item.id == "udpInternalEgressPacketsCount") {
            var optionFll = this.udpInternalEgressPacketsCountOption;
          } else if (item.id == "udpInternalIngressBytesCount") {
            var optionFll = this.udpInternalIngressBytesCountOption;
          } else if (item.id == "udpInternalIngressPacketsCount") {
            var optionFll = this.udpInternalIngressPacketsCountOption;
          } else if (item.id == "udpClosedConnections") {
            var optionFll = this.udpClosedConnectionsOption;
          } else if (item.id == "udpNewConnections") {
            var optionFll = this.udpNewConnectionsOption;
          }

          fullChart.setOption(optionFll);
          window.addEventListener("resize", function () {
            fullChart.resize();
          });
        }
      });
    },
    // 模态框取消事件
    cancel() {
      this.isShowModal = false;
    },
    /******************查询********************************/
    // 查询时间范围
    queryTimeHorizon: function () {
      this.$api.cloudWatch
        .queryTimeHorizon("userName", getCookie(global.cookieName))
        .then((res) => {
          this.timeList = res.data;
        });
    },
    /******************阿里云折线图********************************/
    // 阿里云折线图
    checkAliCloudSLBStatistics: function () {
      this.$api.cloudWatch
        .checkAliCloudSLBStatistics({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          monitorModule: 21,
          instanceId: this.$route.query.loadbalancerId,
          region: this.$route.query.region,
        })
        .then((res) => {
          this.unhealthyServerCount = res.data.unhealthyServerCount;
          this.dropConnection = res.data.dropConnection;
          this.instanceDropConnection = res.data.instanceDropConnection;
          this.instancePacket = res.data.instancePacket;
          this.instancePacketRX = res.data.instancePacketRX;
          this.instancePacketTX = res.data.instancePacketTX;
          this.instanceConnection = res.data.instanceConnection;
          this.instanceActiveConnection = res.data.instanceActiveConnection;
          this.instanceInactiveConnection = res.data.instanceInactiveConnection;
          this.instanceMaxConnection = res.data.instanceMaxConnection;
          this.instanceTrafficRTX = res.data.instanceTrafficRTX;
          this.instanceTrafficRX = res.data.instanceTrafficRX;
          this.instanceTrafficTX = res.data.instanceTrafficTX;
          this.instanceDropTrafficRX = res.data.instanceDropTrafficRX;
          this.instanceDropTrafficTX = res.data.instanceDropTrafficTX;
          this.instanceNewConnection = res.data.instanceNewConnection;
          this.instanceDropTrafficRTX = res.data.instanceDropTrafficRTX;
          this.instanceDropPacketRTX = res.data.instanceDropPacketRTX;
          this.instanceDrops = res.data.instanceDropConnection;
          this.instanceDropPacketRX = res.data.instanceDropPacketRX;
          this.instanceDropPacketTX = res.data.instanceDropPacketTX;
          this.instanceQps = res.data.instanceQps;
          this.instanceQpsUtilization = res.data.instanceQpsUtilization;
          this.instanceNewConnectionUtilization =
            res.data.instanceNewConnectionUtilization;
          this.instanceMaxConnectionUtilization =
            res.data.instanceMaxConnectionUtilization;
          this.instanceUpstreamRt = res.data.instanceUpstreamRt;
          this.instanceUpstreamCode = res.data.instanceUpstreamCode;
          this.instanceUpstreamCode4xx = res.data.instanceUpstreamCode4xx;
          this.instanceUpstreamCode5xx = res.data.InstanceUpstreamCode5xx;
          this.instanceStatusCode = res.data.instanceStatusCode;
          this.instanceStatusCode2xx = res.data.instanceStatusCode2xx;
          this.instanceStatusCode3xx = res.data.instanceStatusCode3xx;
          this.instanceStatusCode4xx = res.data.instanceStatusCode4xx;
          this.instanceStatusCode5xx = res.data.instanceStatusCode5xx;
          this.instanceRt = res.data.instanceRt;
          this.instanceDropTrafficTX = res.data.instanceDropTrafficTX;
          this.instanceDropTrafficRX = res.data.instanceDropTrafficRX;
          this.instanceDropPacketRX = res.data.instanceDropPacketRX;
          this.instanceDropPacketTX = res.data.instanceDropPacketTX;
          this.instanceDrops = res.data.instanceDropConnection;
          this.xaxisData = res.data.xaxisData;
          this.allALY();
        });
    },
    //HTTPS折线图
    checkGcpLoadbalanceIndex: function () {
      this.$api.cloudWatch
        .checkGcpLoadbalanceIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          name: this.$route.query.name,
          monitorModule: 41,
          region: this.$route.query.region,
        })
        .then((res) => {
          this.backendLatencies = res.data.backendLatencies;
          this.backendRequestBytesCount = res.data.backendRequestBytesCount;
          this.backendRequestCount = res.data.backendRequestCount;
          this.backendResponseBytesCount = res.data.backendResponseBytesCount;
          this.internalBackendLatencies = res.data.internalBackendLatencies;
          this.internalRequestCount = res.data.internalRequestCount;
          this.internalRequestBytesCount = res.data.internalRequestBytesCount;
          this.internalResponseBytesCount = res.data.internalResponseBytesCount;
          this.internalTotalLatencies = res.data.internalTotalLatencies;
          this.requestCount = res.data.requestCount;
          this.responseBytesCount = res.data.responseBytesCount;
          this.xaxisData = res.data.xaxisData;
          this.allHTTPS();
        });
    },

    //UDP折线图
    checkGcpLoadbalanceUDPIndex: function () {
      this.$api.cloudWatch
        .checkGcpLoadbalanceIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          name: this.$route.query.name,
          monitorModule: 43,
          region: this.$route.query.region,
        })
        .then((res) => {
          this.udpEgressBytesCount = res.data.udpEgressBytesCount;
          this.udpEgressPacketsCount = res.data.udpEgressPacketsCount;
          this.udpIngressBytesCount = res.data.udpIngressBytesCount;
          this.udpIngressPacketsCount = res.data.udpIngressPacketsCount;
          this.udpInternalEgressBytesCount =
            res.data.udpInternalEgressBytesCount;
          this.udpInternalEgressPacketsCount =
            res.data.udpInternalEgressPacketsCount;
          this.udpInternalIngressBytesCount =
            res.data.udpInternalIngressBytesCount;
          this.udpInternalIngressPacketsCount =
            res.data.udpInternalIngressPacketsCount;
          this.udpClosedConnections = res.data.udpClosedConnections;
          this.udpNewConnections = res.data.udpNewConnections;
          this.xaxisData = res.data.xaxisData;
          this.allUDP();
        });
    },

    //TCP折线图
    checkGcpLoadbalanceTCPIndex: function () {
      this.$api.cloudWatch
        .checkGcpLoadbalanceIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          name: this.$route.query.name,
          monitorModule: 42,
          region: this.$route.query.region,
        })
        .then((res) => {
          this.xaxisData = res.data.xaxisData;
          this.tcpEgressBytesCount = res.data.tcpEgressBytesCount;
          this.tcpEgressPacketsCount = res.data.tcpEgressPacketsCount;
          this.tcpIngressBytesCount = res.data.tcpIngressBytesCount;
          this.tcpIngressPacketsCount = res.data.tcpIngressPacketsCount;
          this.tcpInternalEgressBytesCount =
            res.data.tcpInternalEgressBytesCount;
          this.tcpInternalEgressPacketsCount =
            res.data.tcpInternalEgressPacketsCount;
          this.tcpInternalIngressBytesCount =
            res.data.tcpInternalIngressBytesCount;
          this.tcpInternalIngressPacketsCount =
            res.data.tcpInternalIngressPacketsCount;
          this.tcpClosedConnections = res.data.tcpClosedConnections;
          this.tcpNewConnections = res.data.tcpNewConnections;

          this.allTCP();
        });
    },
    // 切换时间
    changeTimeTypeALY: function () {
      this.checkAliCloudSLBStatistics();
    },
    //HTTPS 切换时间
    changeTimeTypeHTTPS: function () {
      this.checkGcpLoadbalanceIndex();
    },
    //UDP 切换时间
    changeTimeTypeUDP: function () {
      this.checkGcpLoadbalanceUDPIndex();
    },
    //TCP 切换时间
    changeTimeTypeTCP: function () {
      this.checkGcpLoadbalanceTCPIndex();
    },

    allALY: function () {
      this.numberOfBackendAbnormalECSInstancesLine();
      this.instancePacketLine();
      this.instanceConnectionLine();
      this.instanceTrafficRTXLine();
      this.instanceNewConnectionLine();
      this.instanceDropTrafficRTXLine();
      this.instanceDropPacketRTXLine();
      this.instanceDropsLine();
      this.instanceQpsLine();
      this.instanceQpsUtilizationLine();
      this.instanceNewConnectionUtilizationLine();
      this.instanceMaxConnectionUtilizationLine();
      this.instanceUpstreamRtLine();
      this.instanceUpstreamCodeLine();
      this.instanceStatusCodeLine();
      this.instanceRtLine();
      this.instanceDropTrafficTXLine();
      this.instanceDropTrafficRXLine();
      this.instanceDropPacketRXLine();
      this.instanceDropPacketTXLine();
    },
    allHTTPS: function () {
      this.backendLatenciesLine();
      this.backendRequestBytesCountLine();
      this.backendRequestCountLine();
      this.backendResponseBytesCountLine();
      this.internalBackendLatenciesLine();
      this.internalRequestCountLine();
      this.internalRequestBytesCountLine();
      this.internalResponseBytesCountLine();
      this.internalTotalLatenciesLine();
      this.requestCountLine();
      this.responseBytesCountLine();
    },
    allTCP: function () {
      this.tcpEgressBytesCountLine();
      this.tcpEgressPacketsCountLine();
      this.tcpIngressBytesCountLine();
      this.tcpIngressPacketsCountLine();
      this.tcpInternalEgressBytesCountLine();
      this.tcpInternalEgressPacketsCountLine();
      this.tcpInternalIngressBytesCountLine();
      this.tcpInternalIngressPacketsCountLine();
      this.tcpClosedConnectionsLine();
      this.tcpNewConnectionsLine();
    },
    allUDP: function () {
      this.udpEgressBytesCountLine();
      this.udpEgressPacketsCountLine();
      this.udpIngressBytesCountLine();
      this.udpIngressPacketsCountLine();
      this.udpInternalEgressBytesCountLine();
      this.udpInternalEgressPacketsCountLine();
      this.udpInternalIngressBytesCountLine();
      this.udpInternalIngressPacketsCountLine();
      this.udpClosedConnectionsLine();
      this.udpNewConnectionsLine();
    },

    // 后端异常ECS实例个数
    numberOfBackendAbnormalECSInstancesLine: function () {
      this.chartNumberOfBackendAbnormalECSInstances = this.$echarts.init(
        document.getElementById("numberOfBackendAbnormalECSInstances")
      );
      this.numberOfBackendAbnormalECSInstancesOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 后端异常ECS实例个数
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.NumberOfAbnormalBackEndECSInstances"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.NumberOfAbnormalBackEndECSInstances"
            ),
            type: "line",
            data: this.unhealthyServerCount,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartNumberOfBackendAbnormalECSInstances.setOption(
        this.numberOfBackendAbnormalECSInstancesOption
      );
    },
    //数据包数
    instancePacketLine: function () {
      this.chartInstancePacket = this.$echarts.init(
        document.getElementById("instancePacket")
      );
      this.instancePacketOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 流入数据包数 流出数据包数
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InstancePacketRX"),
            this.$t("alarms.network.loadBalancing.line.InstancePacketTX"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.network.loadBalancing.line.InstancePacketRX"),
            type: "line",
            data: this.instancePacketRX,
            itemStyle: {
              normal: {
                color: "#f58db2",
                lineStyle: {
                  color: "#f58db2",
                },
              },
            },
          },
          {
            name: this.$t("alarms.network.loadBalancing.line.InstancePacketTX"),
            type: "line",
            data: this.instancePacketTX,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstancePacket.setOption(this.instancePacketOption);
    },
    // 流量(bits/s)
    instanceTrafficRTXLine: function () {
      this.chartInstanceTrafficRTX = this.$echarts.init(
        document.getElementById("instanceTrafficRTX")
      );
      this.instanceTrafficRTXOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        //ESTABLISHED NON_ESTABLISHED TCP_TOTAL
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InstanceTrafficRX"),
            this.$t("alarms.network.loadBalancing.line.InstanceTrafficTX"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceTrafficRX"
            ),
            type: "line",
            data: this.instanceTrafficRX,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceTrafficTX"
            ),
            type: "line",
            data: this.instanceTrafficTX,
            itemStyle: {
              normal: {
                color: "#00BBFF",
                lineStyle: {
                  color: "#00BBFF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceTrafficRTX.setOption(this.instanceTrafficRTXOption);
    },
    // 新建连接数
    instanceNewConnectionLine: function () {
      this.chartInstanceNewConnection = this.$echarts.init(
        document.getElementById("instanceNewConnection")
      );
      this.instanceNewConnectionOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InstanceNewConnection"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceNewConnection"
            ),
            type: "line",
            data: this.instanceNewConnection,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceNewConnection.setOption(
        this.instanceNewConnectionOption
      );
    },
    // 并发连接数
    instanceConnectionLine: function () {
      this.chartInstanceConnection = this.$echarts.init(
        document.getElementById("instanceConnection")
      );
      this.instanceConnectionOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        //ESTABLISHED NON_ESTABLISHED TCP_TOTAL
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.InstanceActiveConnection"
            ),
            this.$t(
              "alarms.network.loadBalancing.line.InstanceInactiveConnection"
            ),
            this.$t("alarms.network.loadBalancing.line.InstanceMaxConnection"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceActiveConnection"
            ),
            type: "line",
            data: this.instanceActiveConnection,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceInactiveConnection"
            ),
            type: "line",
            data: this.instanceInactiveConnection,
            itemStyle: {
              normal: {
                color: "#00BBFF",
                lineStyle: {
                  color: "#00BBFF",
                },
              },
            },
          },
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceMaxConnection"
            ),
            type: "line",
            data: this.instanceMaxConnection,
            itemStyle: {
              normal: {
                color: "#FFD1FD",
                lineStyle: {
                  color: "#FFD1FD",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceConnection.setOption(this.instanceConnectionOption);
    },
    // 丢弃流量(bits/s)
    instanceDropTrafficRTXLine: function () {
      this.chartInstanceDropTrafficRTX = this.$echarts.init(
        document.getElementById("instanceDropTrafficRTX")
      );
      this.instanceDropTrafficRTXOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        //ESTABLISHED NON_ESTABLISHED TCP_TOTAL
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InstanceDropTrafficRX"),
            this.$t("alarms.network.loadBalancing.line.InstanceDropTrafficTX"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceDropTrafficRX"
            ),
            type: "line",
            data: this.instanceDropTrafficRX,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceDropTrafficTX"
            ),
            type: "line",
            data: this.instanceDropTrafficTX,
            itemStyle: {
              normal: {
                color: "#00BBFF",
                lineStyle: {
                  color: "#00BBFF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceDropTrafficRTX.setOption(
        this.instanceDropTrafficRTXOption
      );
    },
    // 流量(bits/s)
    instanceDropPacketRTXLine: function () {
      this.chartInstanceDropPacketRTX = this.$echarts.init(
        document.getElementById("instanceDropPacketRTX")
      );
      this.instanceDropPacketRTXOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        //ESTABLISHED NON_ESTABLISHED TCP_TOTAL
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InstanceDropPacketRX"),
            this.$t("alarms.network.loadBalancing.line.InstanceDropPacketTX"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceDropPacketTX"
            ),
            type: "line",
            data: this.instanceDropPacketTX,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceDropPacketRX"
            ),
            type: "line",
            data: this.instanceDropPacketRX,
            itemStyle: {
              normal: {
                color: "#00BBFF",
                lineStyle: {
                  color: "#00BBFF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceDropPacketRTX.setOption(
        this.instanceDropPacketRTXOption
      );
    },

    //丢失数据数
    instanceDropsLine: function () {
      this.chartInstanceDrops = this.$echarts.init(
        document.getElementById("instanceDrops")
      );
      this.instanceDropsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InstanceDropConnection"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceDropConnection"
            ),
            type: "line",
            data: this.instanceDropConnection,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceDrops.setOption(this.instanceDropsOption);
    },
    // 7层协议实例QPS
    instanceQpsLine: function () {
      this.chartInstanceQps = this.$echarts.init(
        document.getElementById("instanceQps")
      );
      this.instanceQpsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.network.loadBalancing.line.InstanceQps")],
        },
        series: [
          {
            name: this.$t("alarms.network.loadBalancing.line.InstanceQps"),
            type: "line",
            data: this.instanceQps,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceQps.setOption(this.instanceQpsOption);
    },
    // 7层协议实例QPS使用率
    instanceQpsUtilizationLine: function () {
      this.chartInstanceQpsUtilization = this.$echarts.init(
        document.getElementById("instanceQpsUtilization")
      );
      this.instanceQpsUtilizationOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InstanceQpsUtilization"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceQpsUtilization"
            ),
            type: "line",
            data: this.instanceQpsUtilization,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceQpsUtilization.setOption(
        this.instanceQpsUtilizationOption
      );
    },
    // 实例新建连接数使用率
    instanceNewConnectionUtilizationLine: function () {
      this.chartInstanceNewConnectionUtilization = this.$echarts.init(
        document.getElementById("instanceNewConnectionUtilization")
      );
      this.instanceNewConnectionUtilizationOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.InstanceNewConnectionUtilization"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceNewConnectionUtilization"
            ),
            type: "line",
            data: this.instanceNewConnectionUtilization,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceNewConnectionUtilization.setOption(
        this.instanceNewConnectionUtilizationOption
      );
    },
    // 实例最大连接数使用率
    instanceMaxConnectionUtilizationLine: function () {
      this.chartInstanceMaxConnectionUtilization = this.$echarts.init(
        document.getElementById("instanceMaxConnectionUtilization")
      );
      this.instanceMaxConnectionUtilizationOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.InstanceMaxConnectionUtilization"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceMaxConnectionUtilization"
            ),
            type: "line",
            data: this.instanceMaxConnectionUtilization,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceMaxConnectionUtilization.setOption(
        this.instanceMaxConnectionUtilizationOption
      );
    },
    // 7层协议实例UpstreamRT
    instanceUpstreamRtLine: function () {
      this.chartInstanceUpstreamRt = this.$echarts.init(
        document.getElementById("instanceUpstreamRt")
      );
      this.instanceUpstreamRtOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InstanceUpstreamRt"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceUpstreamRt"
            ),
            type: "line",
            data: this.instanceUpstreamRt,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceUpstreamRt.setOption(this.instanceUpstreamRtOption);
    },
    // 7层协议实例Upstream状态码分布
    instanceUpstreamCodeLine: function () {
      this.chartInstanceUpstreamCode = this.$echarts.init(
        document.getElementById("instanceUpstreamCode")
      );
      this.instanceUpstreamCodeOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.InstanceUpstreamCode4xx"
            ),
            this.$t(
              "alarms.network.loadBalancing.line.InstanceUpstreamCode5xx"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceUpstreamCode4xx"
            ),
            type: "line",
            data: this.InstanceUpstreamCode4xx,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceUpstreamCode5xx"
            ),
            type: "line",
            data: this.InstanceUpstreamCode5xx,
            itemStyle: {
              normal: {
                color: "#00BBFF",
                lineStyle: {
                  color: "#00BBFF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceUpstreamCode.setOption(this.instanceUpstreamCodeOption);
    },
    // 7层协议实例状态码分布
    instanceStatusCodeLine: function () {
      this.chartInstanceStatusCode = this.$echarts.init(
        document.getElementById("instanceStatusCode")
      );
      this.instanceStatusCodeOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InstanceStatusCode2xx"),
            this.$t("alarms.network.loadBalancing.line.InstanceStatusCode3xx"),
            this.$t("alarms.network.loadBalancing.line.InstanceStatusCode4xx"),
            this.$t("alarms.network.loadBalancing.line.InstanceStatusCode5xx"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceStatusCode2xx"
            ),
            type: "line",
            data: this.instanceStatusCode2xx,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceStatusCode3xx"
            ),
            type: "line",
            data: this.InstanceStatusCode3xx,
            itemStyle: {
              normal: {
                color: "#00BBFF",
                lineStyle: {
                  color: "#00BBFF",
                },
              },
            },
          },
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceStatusCode4xx"
            ),
            type: "line",
            data: this.instanceStatusCode4xx,
            itemStyle: {
              normal: {
                color: "#81DAF5",
                lineStyle: {
                  color: "#81DAF5",
                },
              },
            },
          },
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceStatusCode5xx"
            ),
            type: "line",
            data: this.instanceStatusCode5xx,
            itemStyle: {
              normal: {
                color: "#FE9A2E",
                lineStyle: {
                  color: "#FE9A2E",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceStatusCode.setOption(this.instanceStatusCodeOption);
    },
    // 7层协议实例RT
    instanceRtLine: function () {
      this.chartInstanceRt = this.$echarts.init(
        document.getElementById("instanceRt")
      );
      this.instanceRtOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.network.loadBalancing.line.InstanceRt")],
        },
        series: [
          {
            name: this.$t("alarms.network.loadBalancing.line.InstanceRt"),
            type: "line",
            data: this.instanceRt,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceRt.setOption(this.instanceRtOption);
    },
    // 实例每秒丢失出bit数
    instanceDropTrafficTXLine: function () {
      this.chartInstanceDropTrafficTX = this.$echarts.init(
        document.getElementById("instanceDropTrafficTX")
      );
      this.instanceDropTrafficTXOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InstanceDropTrafficTX"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceDropTrafficTX"
            ),
            type: "line",
            data: this.instanceDropTrafficTX,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceDropTrafficTX.setOption(
        this.instanceDropTrafficTXOption
      );
    },
    // 实例每秒丢失入bit数
    instanceDropTrafficRXLine: function () {
      this.chartInstanceDropTrafficRX = this.$echarts.init(
        document.getElementById("instanceDropTrafficRX")
      );
      this.instanceDropTrafficRXOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InstanceDropTrafficRX"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceDropTrafficRX"
            ),
            type: "line",
            data: this.instanceDropTrafficRX,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceDropTrafficRX.setOption(
        this.instanceDropTrafficRXOption
      );
    },
    // 实例每秒丢失入包数
    instanceDropPacketRXLine: function () {
      this.chartInstanceDropPacketRX = this.$echarts.init(
        document.getElementById("instanceDropPacketRX")
      );
      this.instanceDropPacketRXOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InstanceDropPacketRX"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceDropPacketRX"
            ),
            type: "line",
            data: this.instanceDropPacketRX,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceDropPacketRX.setOption(this.instanceDropPacketRXOption);
    },

    // 实例每秒丢失出包数
    instanceDropPacketTXLine: function () {
      this.chartInstanceDropPacketTX = this.$echarts.init(
        document.getElementById("instanceDropPacketTX")
      );
      this.instanceDropPacketTXOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InstanceDropPacketTX"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InstanceDropPacketTX"
            ),
            type: "line",
            data: this.instanceDropPacketTX,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInstanceDropPacketTX.setOption(this.instanceDropPacketTXOption);
    },
    /******************AWS折线图********************************/
    // AWS折线图
    checkALBAndNlbStatistics: function () {
      this.$api.cloudWatch
        .checkALBAndNlbStatistics({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          monitorModule: 27,
          instanceId: this.$route.query.loadBalancerArn,
          region: this.$route.query.region,
        })
        .then((res) => {
          // 多磁盘
          this.unHealthyHostCounts = res.data.unHealthyHostCounts;
          if (this.unHealthyHostCounts == undefined) {
            return;
          }
          this.unHealthyHostCountsList = [];
          for (var i = 0; i < this.unHealthyHostCounts.length; i++) {
            if (this.unHealthyHostCounts[i] != null) {
              var UnHealthyHostCountsCopy = new Object();
              UnHealthyHostCountsCopy.name = this.unHealthyHostCounts[i].name;
              this.unHealthyHostCountsList.push(UnHealthyHostCountsCopy);
            }
          }
          this.xaxisDataAWS = res.data.xaxisData;
          this.all();
        });
    },
    /******************GCP https折线图********************************/

    // 后端延迟
    backendLatenciesLine: function () {
      this.chartBackendLatencies = this.$echarts.init(
        document.getElementById("backendLatencies")
      );
      this.backendLatenciesOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.network.loadBalancing.line.BackendLatencies")],
        },
        series: [
          {
            name: this.$t("alarms.network.loadBalancing.line.BackendLatencies"),
            type: "line",
            data: this.backendLatencies,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartBackendLatencies.setOption(this.backendLatenciesOption);
    },
    //后端请求字节
    backendRequestBytesCountLine: function () {
      this.chartBackendRequestBytesCount = this.$echarts.init(
        document.getElementById("backendRequestBytesCount")
      );
      this.backendRequestBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.BackendRequestBytesCount"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.BackendRequestBytesCount"
            ),
            type: "line",
            data: this.backendRequestBytesCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartBackendRequestBytesCount.setOption(
        this.backendRequestBytesCountOption
      );
    },
    //后端请求计数
    backendRequestCountLine: function () {
      this.chartBackendRequestCount = this.$echarts.init(
        document.getElementById("backendRequestCount")
      );
      this.backendRequestCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.BackendRequestCount"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.BackendRequestCount"
            ),
            type: "line",
            data: this.backendRequestCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartBackendRequestCount.setOption(this.backendRequestCountOption);
    },

    //后端响应字节
    backendResponseBytesCountLine: function () {
      this.chartBackendResponseBytesCount = this.$echarts.init(
        document.getElementById("backendResponseBytesCount")
      );
      this.backendResponseBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.BackendResponseBytesCount"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.BackendResponseBytesCount"
            ),
            type: "line",
            data: this.backendResponseBytesCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartBackendResponseBytesCount.setOption(
        this.backendResponseBytesCountOption
      );
    },

    //内部负载均衡器后端延迟
    internalBackendLatenciesLine: function () {
      this.chartInternalBackendLatencies = this.$echarts.init(
        document.getElementById("internalBackendLatencies")
      );
      this.internalBackendLatenciesOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.InternalBackendLatencies"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InternalBackendLatencies"
            ),
            type: "line",
            data: this.internalBackendLatencies,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInternalBackendLatencies.setOption(
        this.internalBackendLatenciesOption
      );
    },

    // 内部负载均衡器请求计数
    internalRequestCountLine: function () {
      this.chartInternalRequestCount = this.$echarts.init(
        document.getElementById("internalRequestCount")
      );
      this.internalRequestCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InternalRequestCount"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InternalRequestCount"
            ),
            type: "line",
            data: this.internalRequestCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInternalRequestCount.setOption(this.internalRequestCountOption);
    },

    // 请求字节
    internalRequestBytesCountLine: function () {
      this.chartInternalRequestBytesCount = this.$echarts.init(
        document.getElementById("internalRequestBytesCount")
      );
      this.internalRequestBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.InternalRequestBytesCount"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InternalRequestBytesCount"
            ),
            type: "line",
            data: this.internalRequestBytesCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInternalRequestBytesCount.setOption(
        this.internalRequestBytesCountOption
      );
    },

    // 内部负载均衡器响应字节
    internalResponseBytesCountLine: function () {
      this.chartInternalResponseBytesCount = this.$echarts.init(
        document.getElementById("internalResponseBytesCount")
      );
      this.internalResponseBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.InternalResponseBytesCount"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InternalResponseBytesCount"
            ),
            type: "line",
            data: this.internalResponseBytesCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInternalResponseBytesCount.setOption(
        this.internalResponseBytesCountOption
      );
    },

    // 总延迟
    internalTotalLatenciesLine: function () {
      this.chartInternalTotalLatencies = this.$echarts.init(
        document.getElementById("internalTotalLatencies")
      );
      this.internalTotalLatenciesOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.InternalTotalLatencies"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.InternalTotalLatencies"
            ),
            type: "line",
            data: this.internalTotalLatencies,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInternalTotalLatencies.setOption(
        this.internalTotalLatenciesOption
      );
    },

    // 总延迟
    requestCountLine: function () {
      this.chartRequestCount = this.$echarts.init(
        document.getElementById("requestCount")
      );
      this.requestCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.network.loadBalancing.line.RequestCount")],
        },
        series: [
          {
            name: this.$t("alarms.network.loadBalancing.line.RequestCount"),
            type: "line",
            data: this.requestCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartRequestCount.setOption(this.requestCountOption);
    },

    // 响应字节
    responseBytesCountLine: function () {
      this.chartResponseBytesCount = this.$echarts.init(
        document.getElementById("responseBytesCount")
      );
      this.responseBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.ResponseBytesCount"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.ResponseBytesCount"
            ),
            type: "line",
            data: this.responseBytesCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartResponseBytesCount.setOption(this.responseBytesCountOption);
    },
    /******************GCP tcp折线图********************************/
    // 出口字节数
    tcpEgressBytesCountLine: function () {
      this.chartTcpEgressBytesCount = this.$echarts.init(
        document.getElementById("tcpEgressBytesCount")
      );
      this.tcpEgressBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.TcpEgressBytesCount"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.TcpEgressBytesCount"
            ),
            type: "line",
            data: this.tcpEgressBytesCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartTcpEgressBytesCount.setOption(this.tcpEgressBytesCountOption);
    },

    // 出口数据包计数
    tcpEgressPacketsCountLine: function () {
      this.chartTcpEgressPacketsCount = this.$echarts.init(
        document.getElementById("tcpEgressPacketsCount")
      );
      this.tcpEgressPacketsCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.TcpEgressPacketsCount"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.TcpEgressPacketsCount"
            ),
            type: "line",
            data: this.tcpEgressPacketsCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartTcpEgressPacketsCount.setOption(
        this.tcpEgressPacketsCountOption
      );
    },

    // 入口字节数
    tcpIngressBytesCountLine: function () {
      this.chartTcpIngressBytesCount = this.$echarts.init(
        document.getElementById("tcpIngressBytesCount")
      );
      this.tcpIngressBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.TcpIngressBytesCount"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.TcpIngressBytesCount"
            ),
            type: "line",
            data: this.tcpIngressBytesCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartTcpIngressBytesCount.setOption(this.tcpIngressBytesCountOption);
    },

    // 入口数据包计数
    tcpIngressPacketsCountLine: function () {
      this.chartTcpIngressPacketsCount = this.$echarts.init(
        document.getElementById("tcpIngressPacketsCount")
      );
      this.tcpIngressPacketsCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.TcpIngressPacketsCount"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.TcpIngressPacketsCount"
            ),
            type: "line",
            data: this.tcpIngressPacketsCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartTcpIngressPacketsCount.setOption(
        this.tcpIngressPacketsCountOption
      );
    },

    // 内部负载均衡器出口字节数
    tcpInternalEgressBytesCountLine: function () {
      this.chartTcpInternalEgressBytesCount = this.$echarts.init(
        document.getElementById("tcpInternalEgressBytesCount")
      );
      this.tcpInternalEgressBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.TcpInternalEgressBytesCount"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.TcpInternalEgressBytesCount"
            ),
            type: "line",
            data: this.tcpInternalEgressBytesCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartTcpInternalEgressBytesCount.setOption(
        this.tcpInternalEgressBytesCountOption
      );
    },

    // 内部负载均衡器出口数据包数
    tcpInternalEgressPacketsCountLine: function () {
      this.chartTcpInternalEgressPacketsCount = this.$echarts.init(
        document.getElementById("tcpInternalEgressPacketsCount")
      );
      this.tcpInternalEgressPacketsCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.TcpInternalEgressPacketsCount"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.TcpInternalEgressPacketsCount"
            ),
            type: "line",
            data: this.tcpInternalEgressPacketsCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartTcpInternalEgressPacketsCount.setOption(
        this.tcpInternalEgressPacketsCountOption
      );
    },

    // 内部负载均衡器出口字节数
    tcpInternalIngressBytesCountLine: function () {
      this.chartTcpInternalIngressBytesCount = this.$echarts.init(
        document.getElementById("tcpInternalIngressBytesCount")
      );
      this.tcpInternalIngressBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.TcpInternalIngressBytesCount"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.TcpInternalIngressBytesCount"
            ),
            type: "line",
            data: this.tcpInternalIngressBytesCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartTcpInternalIngressBytesCount.setOption(
        this.tcpInternalIngressBytesCountOption
      );
    },

    // 内部负载均衡器入口数据包数
    tcpInternalIngressPacketsCountLine: function () {
      this.chartTcpInternalIngressPacketsCount = this.$echarts.init(
        document.getElementById("tcpInternalIngressPacketsCount")
      );
      this.tcpInternalIngressPacketsCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.TcpInternalIngressPacketsCount"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.TcpInternalIngressPacketsCount"
            ),
            type: "line",
            data: this.tcpInternalIngressPacketsCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartTcpInternalIngressPacketsCount.setOption(
        this.tcpInternalIngressPacketsCountOption
      );
    },

    // 封闭链接
    tcpClosedConnectionsLine: function () {
      this.chartTcpClosedConnections = this.$echarts.init(
        document.getElementById("tcpClosedConnections")
      );
      this.tcpClosedConnectionsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.TcpClosedConnections"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.TcpClosedConnections"
            ),
            type: "line",
            data: this.tcpClosedConnections,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartTcpClosedConnections.setOption(this.tcpClosedConnectionsOption);
    },

    // 新链接已打开
    tcpNewConnectionsLine: function () {
      this.chartTcpNewConnections = this.$echarts.init(
        document.getElementById("tcpNewConnections")
      );
      this.tcpNewConnectionsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.TcpNewConnections"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.TcpNewConnections"
            ),
            type: "line",
            data: this.tcpNewConnections,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartTcpNewConnections.setOption(this.tcpNewConnectionsOption);
    },

    // 出口字节数
    udpEgressBytesCountLine: function () {
      this.chartUdpEgressBytesCount = this.$echarts.init(
        document.getElementById("udpEgressBytesCount")
      );
      this.udpEgressBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.UdpEgressBytesCount"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.UdpEgressBytesCount"
            ),
            type: "line",
            data: this.udpEgressBytesCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartUdpEgressBytesCount.setOption(this.udpEgressBytesCountOption);
    },

    // 出口数据包计数
    udpEgressPacketsCountLine: function () {
      this.chartUdpEgressPacketsCount = this.$echarts.init(
        document.getElementById("udpEgressPacketsCount")
      );
      this.udpEgressPacketsCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.UdpEgressPacketsCount"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.UdpEgressPacketsCount"
            ),
            type: "line",
            data: this.udpEgressPacketsCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartUdpEgressPacketsCount.setOption(
        this.udpEgressPacketsCountOption
      );
    },

    // 入口字节数
    udpIngressBytesCountLine: function () {
      this.chartUdpIngressBytesCount = this.$echarts.init(
        document.getElementById("udpIngressBytesCount")
      );
      this.udpIngressBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.UdpIngressBytesCount"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.UdpIngressBytesCount"
            ),
            type: "line",
            data: this.udpIngressBytesCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartUdpIngressBytesCount.setOption(this.udpIngressBytesCountOption);
    },

    // 入口数据包计数
    udpIngressPacketsCountLine: function () {
      this.chartUdpIngressPacketsCount = this.$echarts.init(
        document.getElementById("udpIngressPacketsCount")
      );
      this.udpIngressPacketsCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.UdpIngressPacketsCount"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.UdpIngressPacketsCount"
            ),
            type: "line",
            data: this.udpIngressPacketsCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartUdpIngressPacketsCount.setOption(
        this.udpIngressPacketsCountOption
      );
    },

    // 内部负载均衡器出口字节数
    udpInternalEgressBytesCountLine: function () {
      this.chartUdpInternalEgressBytesCount = this.$echarts.init(
        document.getElementById("udpInternalEgressBytesCount")
      );
      this.udpInternalEgressBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.UdpInternalEgressBytesCount"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.UdpInternalEgressBytesCount"
            ),
            type: "line",
            data: this.udpInternalEgressBytesCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartUdpInternalEgressBytesCount.setOption(
        this.udpInternalEgressBytesCountOption
      );
    },

    // 内部负载均衡器出口数据包数
    udpInternalEgressPacketsCountLine: function () {
      this.chartUdpInternalEgressPacketsCount = this.$echarts.init(
        document.getElementById("udpInternalEgressPacketsCount")
      );
      this.udpInternalEgressPacketsCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.UdpInternalEgressPacketsCount"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.UdpInternalEgressPacketsCount"
            ),
            type: "line",
            data: this.udpInternalEgressPacketsCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartUdpInternalEgressPacketsCount.setOption(
        this.udpInternalEgressPacketsCountOption
      );
    },

    // 内部负载均衡器出口字节数
    udpInternalIngressBytesCountLine: function () {
      this.chartUdpInternalIngressBytesCount = this.$echarts.init(
        document.getElementById("udpInternalIngressBytesCount")
      );
      this.udpInternalIngressBytesCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.UdpInternalIngressBytesCount"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.UdpInternalIngressBytesCount"
            ),
            type: "line",
            data: this.udpInternalIngressBytesCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartUdpInternalIngressBytesCount.setOption(
        this.udpInternalIngressBytesCountOption
      );
    },

    // 内部负载均衡器入口数据包数
    udpInternalIngressPacketsCountLine: function () {
      this.chartUdpInternalIngressPacketsCount = this.$echarts.init(
        document.getElementById("udpInternalIngressPacketsCount")
      );
      this.udpInternalIngressPacketsCountOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t(
              "alarms.network.loadBalancing.line.UdpInternalIngressPacketsCount"
            ),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.UdpInternalIngressPacketsCount"
            ),
            type: "line",
            data: this.udpInternalIngressPacketsCount,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartUdpInternalIngressPacketsCount.setOption(
        this.udpInternalIngressPacketsCountOption
      );
    },

    // 封闭链接
    udpClosedConnectionsLine: function () {
      this.chartUdpClosedConnections = this.$echarts.init(
        document.getElementById("udpClosedConnections")
      );
      this.udpClosedConnectionsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.UdpClosedConnections"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.UdpClosedConnections"
            ),
            type: "line",
            data: this.udpClosedConnections,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartUdpClosedConnections.setOption(this.udpClosedConnectionsOption);
    },

    // 新链接已打开
    udpNewConnectionsLine: function () {
      this.chartUdpNewConnections = this.$echarts.init(
        document.getElementById("udpNewConnections")
      );
      this.udpNewConnectionsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.network.loadBalancing.line.UdpNewConnections"),
          ],
        },
        series: [
          {
            name: this.$t(
              "alarms.network.loadBalancing.line.UdpNewConnections"
            ),
            type: "line",
            data: this.udpNewConnections,
            itemStyle: {
              normal: {
                color: "#ABABE7",
                lineStyle: {
                  color: "#ABABE7",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartUdpNewConnections.setOption(this.udpNewConnectionsOption);
    },
    // 切换时间
    changeTimeType: function () {
      this.checkALBAndNlbStatistics();
    },
    all: function () {
      this.unHealthyHostCountsLine();
    },
    // 目标群组健康状态检查（台）
    unHealthyHostCountsLine: function () {
      this.chartUnHealthyHostCounts = this.$echarts.init(
        document.getElementById("unHealthyHostCounts")
      );
      this.unHealthyHostCountsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: this.unHealthyHostCountsList,
        },
        series: this.unHealthyHostCounts,
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisDataAWS.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartUnHealthyHostCounts.setOption(this.unHealthyHostCountsOption);
    },
    /********************************/
    // 点击返回详情页
    ipAddress: function () {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.loadbalancerId = this.$route.query.loadbalancerId;
      this.region = this.$route.query.region;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.loadbalancerType = this.$route.query.loadbalancerType;
      this.loadBalancerArn = this.$route.query.loadBalancerArn;
      this.$router.push({
        path: "/network/slbDetail/",
        query: {
          id: this.id,
          accountId: this.accountId,
          loadbalancerId: this.loadbalancerId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name,
          loadbalancerType: this.loadbalancerType,
          loadBalancerArn: this.loadBalancerArn,
        },
      });
    },
  },
};
</script>

<style scoped>
.slb-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-col-span-6 {
  margin-bottom: 20px;
}
.slb-top {
  width: 100%;
  height: 53px;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>





// WEBPACK FOOTER //
// src/components/monitor/network/slb/slb_dashboard/SLB.vue